import { useEffect } from 'react'

import { isLoadingVar } from 'modulesCommon/store'

type TLoadingCondition = {
  isLoading: boolean
}

const useLoading = ({ isLoading }: TLoadingCondition) =>
  useEffect(() => {
    isLoadingVar(isLoading)
  }, [isLoading])

export default useLoading
